<template>
  <section class="sc-why">
    <div class="sc-why-inner">
      <h2 class="sc-why-title">
        Why Choose Think Zone This Summer？
      </h2>
      <div class="sc-why-cards">
        <div v-for="card in cards" :key="card.title" class="sc-card">
          <div class="sc-card-img-wrap">
            <img v-lazy-load :data-src="card.photo" :alt="card.title" class="sc-card-img">
          </div>
          <h3 class="sc-card-title" v-html="card.title" />
          <p class="sc-card-desc">
            {{ card.desc }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import card1Photo from 'assets/web/images/summerCamp/card1-photo.png';
import card2Photo from 'assets/web/images/summerCamp/card2-photo.png';
import card3Photo from 'assets/web/images/summerCamp/card3-photo.png';

export default {
  name: 'SummerCampWhyChoose',
  data() {
    return {
      cards: [
        {
          photo: card1Photo,
          title: 'Personalized Learning<br>for Every Child',
          desc: 'Every student begins with a diagnostic assessment. We create a personalized learning plan based on each child\'s level and pace — no one-size-fits-all teaching.',
        },
        {
          photo: card2Photo,
          title: 'Clear Progress<br>Real Results',
          desc: 'With diagnostic-driven instruction and clear learning paths, parents can easily see what their child is learning and how they are improving.',
        },
        {
          photo: card3Photo,
          title: 'Build Confidence & Get Ready for<br>the Next Grade',
          desc: 'Whether catching up or moving ahead, Think Zone helps students build confidence, strengthen foundations, and feel ready for the new school year.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-why {
  padding: 100px 0;
  background: #fff;
  font-family: 'Roboto-Flex', sans-serif;

  .sc-why-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 50px;
    align-items: center;
  }

  .sc-why-title {
    font-size: 48px;
    font-weight: 600;
    line-height: 48px;
    color: #44454c;
    text-align: center;
    margin: 0;
    font-family: 'Roboto-Flex', sans-serif;
    width: 100%;
  }

  .sc-why-cards {
    display: flex;
    gap: 40px;
    width: 100%;
    align-items: flex-start;
  }

  .sc-card {
    flex: 1;
    background: #fff;
    border: 1px solid #ededed;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .sc-card-img-wrap {
      width: 100%;
      height: 206px;
      overflow: hidden;
      border-radius: 20px 20px 0 0;

      .sc-card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center top;
        display: block;
      }
    }

    .sc-card-title {
      font-size: 22px;
      font-weight: 600;
      line-height: 28px;
      color: #45454c;
      text-align: center;
      margin: 26px 0 0;
      padding: 0 16px;
      font-family: 'Roboto-Flex', sans-serif;
      text-transform: capitalize;
    }

    .sc-card-desc {
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
      color: #44454c;
      margin: 18px 20px 50px;
      font-family: 'Roboto-Flex', sans-serif;
    }
  }
}
</style>
